document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('#shopify-section-template--27351581131134__section_DGLCHD .custom-section-content > div');
  
  if (!section) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, { 
    threshold: 0.2,
    rootMargin: '0px 0px -50px 0px'
  });

  observer.observe(section);
});
